import { useAuthContext } from '@/contexts/AuthContext';

const useHasUserPermissions = (permissionKeys: string[]) => {
  const { user } = useAuthContext();

  return permissionKeys.every((permissionKey) =>
    user?.permissions.some((p) => p.key === permissionKey),
  );
};

export default useHasUserPermissions;
